import {TRANSLATION, FORECASTS} from "Core/mc/matches/match-ajax-tabs";

const tabSlugToUrlMap = {};

tabSlugToUrlMap[TRANSLATION] = '/rest/matchcenter/matches/translation';
//tabSlugToUrlMap[FORECASTS] = '/rest/matchcenter/matches/forecasts';


export const resolveMatchAjaxTabUrl = (tabSlug) => {
    return tabSlugToUrlMap[tabSlug];
};
